import { StatusCode } from 'services/api/flagbags/types';
import { StatusLabel } from 'services/api/flagbags/types';

export enum ScanType{
  DISTRIBUTE_MODE = 2,
  COLLECT_MODE = 3,
  COLLECT_EMPTY_MODE = 4,
  COLLECT_BANK_MODE = 5
}


export const ScanTypeLabel = {
  [ScanType.DISTRIBUTE_MODE]: StatusLabel[StatusCode.DISTRIBUTED],
  [ScanType.COLLECT_MODE]:StatusLabel[StatusCode.COLLECTED],
  [ScanType.COLLECT_EMPTY_MODE]:StatusLabel[StatusCode.COLLECTED_EMPTY],
  [ScanType.COLLECT_BANK_MODE]:StatusLabel[StatusCode.BANK],
}

export const convertScanTypeToStatusCode = (scanType:ScanType):StatusCode =>{
  switch (scanType) {
    case ScanType.DISTRIBUTE_MODE:
        return StatusCode.DISTRIBUTED;
    case ScanType.COLLECT_MODE:
        return StatusCode.COLLECTED;
    case ScanType.COLLECT_EMPTY_MODE:
        return StatusCode.COLLECTED_EMPTY;
    case ScanType.COLLECT_BANK_MODE:
        return StatusCode.BANK;
    default:
        return null;
}
}